import HttpRequest from './http_request'

class UserProvider extends HttpRequest {
  constructor() {
    super(process.env.VUE_APP_API_URL)
  }

  // StudentData
  async getStudentData(student_id) {
    const { data } = await this.get('/', {
      function: 'get-student-data',
      student_id,
    })
    return data
  }

  async getStudentCardPhoto(student_id) {
    const { data } = await this.get('/', {
      function: 'get-student-card-photo',
      student_id,
    }, {
      responseType: 'blob',
    })
    return data
  }

  async checkStudentAndRegis({
      student_id, 
      year, 
      semester
    }) {
    const { data } = await this.get('/', {
      function: 'check-student-and-regis',
      student_id,
      year,
      semester
    });
    return data
  }
}

export default UserProvider
